import apiClient from '../apiClient';
import { GET_TOUR_OPERATOR_MARGIN_BY_PROFILE_ID_URL } from '../apiUrl';

const getTourOperatorMarginByProfileIdApi = Id => {
  return apiClient.get(GET_TOUR_OPERATOR_MARGIN_BY_PROFILE_ID_URL(Id));
};

export default getTourOperatorMarginByProfileIdApi;
